<template>
	<span>
		<v-icon
			v-if="!loading"
			color="accent"
			title="ScDoc für Produktion herunterladen"
			@click="downloadCadFile(articleId)"
		>
			file_download
		</v-icon>
		<v-progress-circular v-else indeterminate color="accent"> </v-progress-circular>
	</span>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	props: {
		articleId: 0,
		translate: true,
		name: "",
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		async downloadCadFile() {
			try {
				console.log(this.translate);
				this.loading = true;
				let response = await httpClient().get(
					`api/Artikel/getCadFile?partId=${this.articleId}&fertigerId=${this.$route.params.fertigerId}&translate=${this.translate}`,
					{
						responseType: "blob",
					}
				);
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				if (this.name == undefined) {
					link.setAttribute("download", "Artikel " + this.articleId + ".scdoc");
				} else {
					link.setAttribute("download", this.name);
				}
				link.click();
			} catch (err) {
				console.log(err);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
